import { Grid } from '@mui/material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  BasicTable,
  Breadcrumbs,
  CardComponent,
  DashedStandardDropdown,
  PageTitleAndSubTitle,
  Knife,
  Columns,
  Button,
  Download,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import axios from 'axios';
import { observer } from 'mobx-react-lite';
import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  addPrefix,
  commasForNumbers,
  placeOfService,
  typeOfService,
} from '../../core-utils/helper-utils/helper';
import {
  frequencyCloumns,
  getTableHeader,
  ProcedureFrequnecy,
  ProcedureSpend,
  TOP_PROCEDURES,
} from '../../core-utils/helper-utils/utilizattionProcedureHelper';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { utilizationmessages } from '../../core-utils/messages/utilizationProcedureConstants';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import { useNavigate } from 'react-router-dom';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
import {
  UserAccessConstants,
  checkUserAccess,
} from '../../core-utils/helper-utils/userAccess';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  formatProceduresListData,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import {
  downloadPdf,
  handleDownloadCSV,
  handleDownloadTopProcedureCSV,
} from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import componentConstants from '../../core-utils/messages/componentConstants';
// import { DottedText } from '../../core-utils/helper-utils/financialForensicsHelper';
import { DEEP_DIVE } from '../../core-utils/routes';
import { DynamicFilter } from '../../_components/molecules/DynamicFilter';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';

export interface UtilizationProcedurePageProps {}

const UtilizationProcedurePage: React.FC<UtilizationProcedurePageProps> = observer(
  ({}) => {
    const [tableLoading, setTableLoading] = useState<boolean>(true);
    const [customTableLoading, setCustomTableLoading] = useState<boolean>(true);
    const [
      proceduresDropdownValue,
      setProceduresDropdownValue,
    ] = useState<string>('Procedure Cost');

    const [procedureSpend, setProcedureSpend] = useState<ProcedureSpend[]>([]);
    const [procedureFrequency, setProcedureFrequency] = useState<
      ProcedureFrequnecy[]
    >([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const navigate = useNavigate();
    const [openReportsModal, setOpenReportsModal] = useState(false);
    const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);

    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
    const [columnId, setColumnId] = useState<string>();

    const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
      false,
    );
    const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
      false,
    );
    const {
      employerGroupStore,
      quaterlyReportStore,
      loginPageStore,
      cohortDetailsStore,
      recommendedTabStore,
    } = useStores();

    const {
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      isIncurredDate,
      isPaidDate,
      isPlanDatesFetched,
      aggregationParameter,
    } = quaterlyReportStore;

    const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
    const payload = useAPIPayload();
    const { open, openModal, closeModal, isEditMode } = useCohortModal();

    const { totalResults, isInitializing } = useCohortOnPageLoad({
      fetchTotalResults: () =>
        getCohortMembersCount(
          employerGroupStore.employerGroupResponseData.eg_nid,
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          employerGroupStore.employerGroupResponseData.max_claim_date,
        ),
      enabled:
        isPlanDatesFetched &&
        !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    });
    const abortController = new AbortController();
    const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
    const [filterResetKey, setFilterResetKey] = useState(0);
    const [aiLoading, setAiLoading] = useState<boolean>(false);
    const screenName = allScreenLabel;
    const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
    const [aiSummaryData, setAiSummaryData] = useState<
      { title: string; description: string }[]
    >([]);

    const handleOnClick = (procedure: string) => {
      navigate(DEEP_DIVE, {
        state: {
          key: 'procedure_desc_01',
          value: procedure,
        },
      });
    };

    const handleSelectedIndex = (index: number) => {
      setSelectedTabIndex(index);
      if (!recommendationFetched) {
        getRecommendationsData(
          employerGroupStore?.employerGroupResponseData?.eg_nid,
          utilizationmessages.page.title,
          recommendedTabStore,
          setRecommendationLoading,
        );
        setRecommendationFetched(true);
      }
    };

    const handleSort = (event: any, column: any, item: any) => {
      const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
      const { sortColumnName } = column;
      if (!sortColumnName) {
        return;
      }

      getTopProcedures(sortOrder);
    };

    const getProcedureSpend = async (sortOrder = -1) => {
      const controller = new AbortController();

      const columnFlag = frequencyCloumns.some(
        (el) => el.sortColumnName === columnId,
      );
      const baseurl =
        properties.aiqBaseUrl +
        properties.utilizationSummary +
        properties.procedureCostSpend;
      const reqBody = {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        pageNumber: pageNumber - 1,
        sortField: columnFlag ? columnId : 'totalCost',
        sortOrder: sortOrder,
        category: selectedCategory,
      };
      setTableLoading(true);
      await axios
        .post(baseurl, reqBody, { signal: controller.signal })
        .then((res) => {
          if (res.status === 200) {
            const totalItems = res?.data?.data?.totalCount;
            const totalPages = Math.ceil(totalItems / 10);
            setTotalPages(totalPages);
            setProcedureSpend(res.data?.data?.procedures);
          }
        })
        .catch((error) => {
          setTableLoading(false);
          return error;
        });
      setTableLoading(false);
    };

    const getProcedureFrequency = async (sortOrder = -1) => {
      const columnFlag = frequencyCloumns.some(
        (el) => el.sortColumnName === columnId,
      );
      const baseurl =
        properties.aiqBaseUrl +
        properties.utilizationSummary +
        properties.procedureCostFreQuency;
      const reqBody = {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        pageNumber: pageNumber - 1,
        sortField: columnFlag ? columnId : 'claims',
        sortOrder: sortOrder,
      };
      setTableLoading(true);
      await axios
        .post(baseurl, reqBody, { signal: abortController.signal })
        .then((res) => {
          if (res.status === 200) {
            const totalItems = res?.data?.data?.totalCount;
            const totalPages = Math.ceil(totalItems / 10);
            setTotalPages(totalPages);
            setProcedureFrequency(res.data?.data?.procedures);
          }
        })
        .catch((error) => {
          setTableLoading(false);
          return error;
        });
      setTableLoading(false);
    };

    const getAiSummarizedData = async (spendData: any, frequencyData: any) => {
      try {
        const apiResponses = {
          title_1: spendData,
          title_2: frequencyData,
        };
        let resultArray = []; // ✅ default fallback

        try {
          const response = await axios.post(
            properties.aiqBaseUrl +
              properties.contractBaseUrl +
              properties.getAiSummary,
            {
              screenName: screenName.UTILIZATION_PROCEDURE,
              eg_nid:
                employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
              incurredStartDate,
              incurredEndDate,
              paidStartDate,
              paidEndDate,
              apiData: apiResponses,
            },
          );

          // ✅ Safe extraction
          resultArray = response?.data?.data?.data?.result || [];
          setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
        } catch (apiError) {
           
          console.error('AI Summary API failed:', apiError);
          // ✅ Optional: show user-friendly message
          handleOpenSnackBar('Failed to load summary', 'warning', 4000);
          setAiSummaryData([]);
        }
      } catch (error) {
        console.error('AI summarization failed:', error);
      }
    };

    const [snackbarState, setSnackbarState] = React.useState<{
      open: boolean;
      message: string;
      severity: MuiColor | undefined;
      duration: null | number;
    }>({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });

    const [selectedColumns, setSelectedColumns] = useState<string[]>([
      'Procedure',
      'Type Of Service',
      'Place Of Service',
    ]);
    const [tableColumns, setTableColumns] = useState<Columns[]>(
      getColumns(
        [
          'Procedure',
          'Type Of Service',
          'Place Of Service',
          'Claim Count',
          'Total Cost',
          'Plan Paid Cost',
          'Previous Year Cost',
          'Previous Claim Count',
        ],
        false,
      ),
    );

    const [sortFieldCustom, setSortFieldCustom] = useState<string>('totalCost');
    const [sortOrderCustom, setSortOrderCustom] = useState<number>(-1);
    const [totalPagesCustom, setTotalPagesCustom] = useState(0);

    const [pageSize] = useState(10);
    const [pageNumberCustom, setPageNumberCustom] = useState(1);
    const [proceduresListData, setProceduresListData] = useState<any[]>([]);

    // filter states
    const [filterValues, setFilterValues] = useState<Record<string, string>>(
      {},
    );
    const [selectedCategory, setSelectedCategory] = useState<string | null>(
      null,
    );

    const filterOptions = [
      {
        label: 'Surgical/Nonsurgical',
        options: ['Surgical', 'Nonsurgical'],
        selected: filterValues['Surgical/Nonsurgical'] || null,
        onChange: (value: string) =>
          setFilterValues((prev) => ({
            ...prev,
            'Surgical/Nonsurgical': value,
            'Type Of Service': '',
            'Place Of Service': '',
          })),
      },
      {
        label: 'Type Of Service',
        options: typeOfService,
        selected: filterValues['Type Of Service'] || null,
        onChange: (value: string) =>
          setFilterValues((prev) => ({
            ...prev,
            'Type Of Service': value,
            'Surgical/Nonsurgical': '',
            'Place Of Service': '',
          })),
      },
      {
        label: 'Place Of Service',
        options: placeOfService,
        selected: filterValues['Place Of Service'] || null,
        onChange: (value: string) =>
          setFilterValues((prev) => ({
            ...prev,
            'Place Of Service': value,
            'Surgical/Nonsurgical': '',
            'Type Of Service': '',
          })),
      },
    ];
    const filterOptionsForCategory = [
      {
        label: 'Surgical',
        options: [],
        selected: selectedCategory === 'Surgical' ? 'Surgical' : null,
        onChange: () => setSelectedCategory('Surgical'),
        isSingleLevel: true,
      },
      {
        label: 'Non-surgical',
        options: [],
        selected: selectedCategory === 'Non-surgical' ? 'Non-surgical' : null,
        onChange: () => setSelectedCategory('Nonsurgical'),
        isSingleLevel: true,
      },
      {
        label: 'Medpharma',
        options: [],
        selected: selectedCategory === 'Medpharma' ? 'Medpharma' : null,
        onChange: () => setSelectedCategory('Medpharma'),
        isSingleLevel: true,
      },
    ];

    const handleOpenSnackBar = (
      message: string,
      severity: MuiColor,
      duration: number | null,
    ) => {
      setSnackbarState({
        open: true,
        message: message,
        severity: severity,
        duration: duration,
      });
    };

    const handleCloseSnackBar = (
      event?: React.SyntheticEvent,
      reason?: string,
    ) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackbarState({
        open: false,
        message: '',
        severity: undefined,
        duration: null,
      });
    };

    const handlePageChangeCustom = (
      event: ChangeEvent<unknown>,
      page: number,
    ) => {
      setPageNumberCustom(page);
    };

    const handleChangeColumnsCustom = () => {
      setTableColumns(
        getColumns(
          [
            ...selectedColumns,
            'Claim Count',
            'Total Cost',
            'Plan Paid Cost',
            'Previous Year Cost',
            'Previous Claim Count',
          ],
          false,
        ),
      );
      getProceduresList();
    };

    const handleSortCustom = (event: any, column: any, item: any) => {
      const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
      const { sortColumnName } = column;
      if (!sortColumnName) {
        return;
      }

      setSortFieldCustom(sortColumnName);
      setSortOrderCustom(sortOrder);
    };

    const handleExportCSV = () => {
      handleDownloadCSV(
        properties.aiqBaseUrl +
          properties.utilizationSummary +
          properties.procedureDetailsCSV,
        { ...membersListRequestBody, showAll: true },
        `procedures.csv`,
        handleOpenSnackBar,
      );
    };
    const handleDownloadTopProcedure = () => {
      const isCostView = proceduresDropdownValue === 'Procedure Cost';
      const columnFlag = frequencyCloumns.some(
        (el) => el.sortColumnName === columnId,
      );

      const sortField = columnFlag
        ? columnId
        : isCostView
        ? 'totalCost'
        : 'claims';

      const csvUrl =
        properties.aiqBaseUrl +
        properties.utilizationSummary +
        (isCostView
          ? properties.procedureCostSpendCSV
          : properties.procedureCostFreQuencyCSV);

      const requestBody = {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        sortField,
        sortOrder: -1,
        showAll: true,
        ...(selectedCategory && { category: selectedCategory }),
      };

      handleDownloadTopProcedureCSV(
        csvUrl,
        requestBody,
        isCostView ? 'top_procedures_cost.csv' : 'top_procedures_volume.csv',
        handleOpenSnackBar,
        isCostView,
      );
    };

    const previousYearCostSortFields = ['previousYearCost', 'previousClaims'];

    const membersListRequestBody = {
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      pageNumber: pageNumberCustom - 1,
      pageSize: pageSize,
      sortField: sortFieldCustom,
      sortOrder: sortOrderCustom,
      ...payload,
      columnList: [
        ...selectedColumns,
        'Claim Count',
        'Total Cost',
        'Plan Paid Cost',
        'Previous Year Cost',
        'Previous Claim Count',
        'Surgical',
      ],
      showAll: previousYearCostSortFields?.includes(sortFieldCustom),
    } as any;
    if (filterValues['Surgical/Nonsurgical']) {
      membersListRequestBody.surgicalFilter =
        filterValues['Surgical/Nonsurgical'] === 'Surgical' ? 'Yes' : 'No';
    }
    if (filterValues['Type Of Service']) {
      membersListRequestBody.typeOfServiceFilter =
        filterValues['Type Of Service'];
    }

    if (filterValues['Place Of Service']) {
      membersListRequestBody.placeOfServiceFilter =
        filterValues['Place Of Service'];
    }

    const getProceduresList = async () => {
      setCustomTableLoading(true);

      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.utilizationSummary +
          properties.procedureDetails,
        membersListRequestBody,
        { signal: abortController.signal },
      );

      if (response?.status === 200) {
        setTotalPagesCustom(Math.ceil(response?.data?.data?.total / pageSize));
        setProceduresListData(
          formatProceduresListData(
            response?.data?.data?.data,
            [
              ...selectedColumns,
              'Claim Count',
              'Total Cost',
              'Plan Paid Cost',
              'Previous Year Cost',
              'Previous Claim Count',
            ],
            handleOnClick,
          ),
        );
        setCustomTableLoading(false);
      }
    };

    const handleAskAi = async () => {
      setActiveAskAi(true);
      setAiLoading(true);

      const spendUrl =
        properties.aiqBaseUrl +
        properties.utilizationSummary +
        properties.procedureCostSpend;

      const frequencyUrl =
        properties.aiqBaseUrl +
        properties.utilizationSummary +
        properties.procedureCostFreQuency;

      const reqBody = {
        ...payload,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        sortField: 'totalCost',
        sortOrder: -1,
        category: selectedCategory,
        showAll: true,
      };

      try {
        const [spendRes, frequencyRes] = await Promise.all([
          axios.post(spendUrl, reqBody),
          axios.post(frequencyUrl, reqBody),
        ]);

        const procedureSpendData = spendRes?.data?.data?.procedures ?? [];

        const procedureFrequencyData =
          frequencyRes?.data?.data?.procedures ?? [];

        // Ensure both APIs returned data before calling AI
        if (
          procedureSpendData.length > 0 ||
          procedureFrequencyData.length > 0
        ) {
          await getAiSummarizedData(procedureSpendData, procedureFrequencyData);
        }
      } catch (error) {
        console.error('Ask AI error:', error);
      } finally {
        setAiLoading(false);
      }
    };

    const getTopProcedures = async (sortOrder = -1) => {
      await getProcedureSpend(sortOrder);
      await getProcedureFrequency(sortOrder);
    };

    const filterByCategory = <T extends { procedureFlag?: string }>(
      data: T[],
    ) => {
      if (!selectedCategory) {
        return data;
      }

      return data.filter(
        (item) =>
          item.procedureFlag?.toLowerCase() === selectedCategory.toLowerCase(),
      );
    };

    const handleResetCategoryFilter = () => {
      setSelectedCategory(null);
      setPageNumber(1);
      setFilterResetKey((prev) => prev + 1);
    };

    useEffect(() => {
      const fetchPlanDates = async () => {
        if (!isPlanDatesFetched) {
          await getPlanDates();
        }
      };
      fetchPlanDates();
    }, []);

    useEffect(() => {
      if (isInitializing) {
        return;
      }
      getTopProcedures();

      return () => {
        abortController.abort();
      };
    }, [
      isInitializing,
      selectedCategory,
      isPlanDatesFetched,
      isIncurredDate,
      isPaidDate,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      pageNumber,
      cohortDetailsStore.conditionsDetails,
      employerGroupStore.employerGroupResponseData,
    ]);

    useEffect(() => {
      if (isInitializing) {
        return;
      }
      getProceduresList();
      return () => {
        abortController.abort();
      };
    }, [
      isInitializing,
      isPlanDatesFetched,
      isIncurredDate,
      isPaidDate,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      employerGroupStore.employerGroupResponseData,
      pageNumberCustom,
      sortFieldCustom,
      sortOrderCustom,
      filterValues['Surgical/Nonsurgical'],
      filterValues['Type Of Service'],
      filterValues['Place Of Service'],
      cohortDetailsStore.conditionsDetails,
    ]);

    //using state Variables and jsx elements
    const formatProcedureName = (procedure: string, procedureFlag: string) => {
      const isSurgical = procedureFlag?.toLowerCase() === 'surgical';
      return (
        <Grid
          container
          direction="row"
          style={{ overflowWrap: 'break-word' }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid>
            {isSurgical ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '10px',
                }}
              >
                <Knife style={{ height: '24px', width: '24px' }} />
              </div>
            ) : (
              <></>
            )}
          </Grid>
          <Grid style={{ flex: 1 }}>
            <Typography
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              fontSize="14px"
              fontType="regular"
              lineHeight="24px"
            >
              {procedure}
            </Typography>
          </Grid>
        </Grid>
      );
    };
    const formatSpendTableData = (spend: ProcedureSpend[]) => {
      const spendData: any[] = [];
      spend?.map((item) => {
        const element: any = {
          procedure: '',
          cost: 0,
          planPaid: 0,
          memberPaid: 0,
        };
        element.procedure = formatProcedureName(
          item.procedure,
          item.procedureFlag,
        );
        element.cost = addPrefix(
          '$',
          commasForNumbers(item.totalCost?.toString(), 2),
        );
        element.planPaid = addPrefix(
          '$',
          commasForNumbers(item.totalPlanPaid?.toString(), 2),
        );
        element.memberPaid = addPrefix(
          '$',
          commasForNumbers(item.totalMemberPaid?.toString(), 2),
        );
        spendData.push([
          element.procedure,
          element.cost,
          element.planPaid,
          element.memberPaid,
        ]);
      });
      return spendData;
    };

    const formatFrequnecyTableData = (frequency: ProcedureFrequnecy[]) => {
      const frequencyData: any[] = [];
      frequency?.map((item) => {
        const element: any = {
          procedure: '',
          cost: 0,
          claimants: 0,
          calims: 0,
        };
        element.procedure = formatProcedureName(
          item.procedure,
          item.procedureFlag,
        );
        element.cost = addPrefix(
          '$',
          commasForNumbers(item.totalCost?.toString(), 2),
        );
        element.claimants = item.claimants;
        element.claims = item.claims;
        frequencyData.push([
          element.procedure,
          element.cost,
          element.claimants,
          element.claims,
        ]);
      });
      return frequencyData;
    };

    const finalTableData = (proceduresDropdownValue: string) => {
      if (proceduresDropdownValue === 'Procedure Cost') {
        return formatSpendTableData(filterByCategory(procedureSpend));
      }
      return formatFrequnecyTableData(filterByCategory(procedureFrequency));
    };

    const [loader] = useState<any>(<Loader />);

    const isPageLoading = isPlanDatesLoading || isInitializing;

    return (
      <>
        {isPageLoading ? (
          loader
        ) : (
          <Grid
            container
            direction="row"
            style={{
              marginLeft: '100px',
              marginTop: '38px',
              width: '1182px',
              paddingBottom: '60px',
            }}
          >
            <Grid>
              <Breadcrumbs
                itemList={[
                  [
                    'text',
                    'Medical Claim Utilization',
                    {
                      color: patientAccessTheme.palette.primary[500],
                      fontWeight: 500,
                    },
                    () => {
                      navigate(-1);
                    },
                  ],
                  [
                    'text',
                    utilizationmessages.page.title,
                    {
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    },
                  ],
                ]}
              />
            </Grid>
            <Grid
              style={{
                marginTop: '20px',
                position: 'relative',
                width: '100%',
              }}
            >
              <div>
                <PageTitleAndSubTitle
                  title={utilizationmessages.page.title}
                  subTitle={utilizationmessages.page.subTitle}
                  showDownloadButton={true}
                  // downloadButtonAction={() => setOpenReportsModal(true)}
                  downloadButtonAction={() => {
                    downloadPdf(
                      'utilizationProcedureReport',
                      {
                        employer:
                          employerGroupStore?.employerGroupResponseData
                            ?.employer_group_name,
                        member_unique_id_list: [],
                        claim_id_list: [],
                        maxClaimDate:
                          employerGroupStore?.employerGroupResponseData
                            ?.max_claim_date,
                        ...payload,
                      },
                      handleOpenSnackBar,
                      'open',
                    );
                    handleOpenSnackBar(
                      snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                      'info',
                      6000,
                    );
                  }}
                  showQueryDataButton={checkUserAccess(
                    UserAccessConstants.COHORT_DETAILS,
                    loginPageStore.userResponse.role.name,
                    loginPageStore.userFeatures,
                  )}
                  queryButtonText={
                    cohortDetailsStore.cohortDetailsList?.length > 0 &&
                    cohortDetailsStore.cohortDetailsList[0].category !== ''
                      ? 'Edit Cohort'
                      : 'Add Cohort'
                  }
                  queryDataAction={() => {
                    if (
                      checkUserAccess(
                        UserAccessConstants.COHORT_DETAILS,
                        loginPageStore.userResponse.role.name,
                        loginPageStore.userFeatures,
                      )
                    ) {
                      openModal();
                    }
                  }}
                  showAskAi={true}
                  askAiAction={handleAskAi}
                />
              </div>
              {/* edit duration */}
              <div
                style={{
                  position: 'absolute',
                  top: '-2px',
                  left: '183px',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  {COMMON_TEXTS.FOR}
                </Typography>
                <DateFilter />
              </div>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>
            <CohortFilterBar />
            {selectedTabIndex === 0 && (
              <>
                <Grid style={{ marginTop: '28px' }}>
                  <CardComponent
                    title={TOP_PROCEDURES.TITLE}
                    subTitle={
                      TOP_PROCEDURES.SUB_TITLE +
                      (proceduresDropdownValue === 'Procedure Cost'
                        ? 'cost'
                        : 'volume')
                    }
                    width="1177px"
                    height="fit-content"
                    topRightItem={
                      <Grid
                        style={{
                          display: 'flex',
                          gap: 10,
                        }}
                      >
                        <Button
                          variant="outlined"
                          label={'Export CSV'}
                          startIcon={
                            <Download
                              strokeWidth={1}
                              width={'20px'}
                              height={'20px'}
                            />
                          }
                          styleProps={{
                            width: '134px',
                            height: '37px',
                          }}
                          color="primary"
                          borderRadius="4px"
                          onClick={handleDownloadTopProcedure}
                        />
                        <DynamicFilter
                          filterOptions={filterOptionsForCategory}
                          resetKey={filterResetKey}
                        />
                        {selectedCategory && (
                          <Button
                            label="Reset Filter"
                            width="auto"
                            variant="outlined"
                            onClick={handleResetCategoryFilter}
                            // height="34px"
                            styleProps={{
                              marginTop: '3px',
                              height: '36px',
                            }}
                          />
                        )}
                      </Grid>
                    }
                    dropdownElement={
                      <DashedStandardDropdown
                        options={TOP_PROCEDURES.DROPDOWN_OPTIONS}
                        displayValue={TOP_PROCEDURES.DROPDOWN_OPTIONS}
                        value={proceduresDropdownValue}
                        handleChange={(event: any) => {
                          const value: string = event.target.value as string;
                          setProceduresDropdownValue(value);
                          setPageNumber(1);
                        }}
                      />
                    }
                    body={
                      <>
                        <Grid>
                          {tableLoading ? (
                            <Grid
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '500px',
                              }}
                            >
                              <CircularLoader />
                            </Grid>
                          ) : (
                            <BasicTable
                              width="1136px"
                              columns={getTableHeader(proceduresDropdownValue)}
                              cellHeight="44px"
                              headerCellHeight="56px"
                              cellPadding="12px 18px 12px 28px"
                              rowsData={finalTableData(proceduresDropdownValue)}
                              columnId={columnId}
                              handleHeaderMouseEnter={(column: any) =>
                                handleHeaderMouseEnter(column, setColumnId)
                              }
                              handleHeaderMouseLeave={() =>
                                handleHeaderMouseLeave(setColumnId)
                              }
                              showOnHoverHeader={true}
                              handleMenuItem={handleSort}
                              displayType="row"
                              tableHeight="fit-content"
                              pageNumber={pageNumber}
                              pageCount={totalPages}
                              showPagination={true}
                              handlePagination={(
                                event: ChangeEvent<unknown>,
                                page: number,
                              ) => setPageNumber(page)}
                            />
                          )}
                        </Grid>
                        <Grid style={{ marginTop: '30px' }}>
                          <Grid>
                            <Knife />
                          </Grid>
                          <Grid
                            style={{ marginTop: '-18px', marginLeft: '15px' }}
                          >
                            <Typography
                              fontSize="12px"
                              textColor={
                                patientAccessTheme.palette.text.mediumemphasis
                              }
                              fontType="medium"
                              lineHeight="12px"
                            >
                              - Surgical
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                    }
                  />
                </Grid>

                <Grid id="member-details" style={{ marginTop: '28px' }}>
                  <CustomColumnsTable
                    title={
                      <Grid>
                        <Typography
                          fontSize="16px"
                          lineHeight="24px"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                          fontType="semiBold"
                          margin="2px 8px 0px 0px"
                        >
                          {utilizationmessages.ProcedureAndService.title}
                        </Typography>
                      </Grid>
                    }
                    subTitle={utilizationmessages.ProcedureAndService.subTitle}
                    options={[
                      'Procedure',
                      'Type Of Service',
                      'Place Of Service',
                    ]}
                    anyOneMandate={[
                      'Procedure',
                      'Type Of Service',
                      'Place Of Service',
                    ]}
                    isCollapsiblePatientTable={false}
                    selectedItems={selectedColumns}
                    setSelectedItems={setSelectedColumns}
                    handleChangeColumns={handleChangeColumnsCustom}
                    handleExport={handleExportCSV}
                    columns={tableColumns}
                    rowsData={proceduresListData}
                    tableLoading={customTableLoading}
                    handleSort={handleSortCustom}
                    totalPages={totalPagesCustom}
                    handlePageChange={handlePageChangeCustom}
                    pageNumber={pageNumberCustom}
                    isFilter={true}
                    filterOptions={filterOptions}
                  />
                </Grid>
              </>
            )}
            {selectedTabIndex === 1 && (
              <div style={{ width: '1500px', padding: '20px' }}>
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                  isInternalPage={true}
                />
              </div>
            )}
          </Grid>
        )}
        <ReportsModal
          open={openReportsModal}
          setOpen={setOpenReportsModal}
          startDate={
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
          }
          endDate={
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
          }
        />
        <CohortDetailsModal
          open={open}
          handleClose={closeModal}
          totalResults={totalResults}
          isEditMode={isEditMode}
        />
        <FeatureAccessModal
          open={openFeatureAccessModal}
          handleClose={() => {
            setOpenFeatureAccessModal(false);
          }}
          access={checkUserAccess(
            UserAccessConstants.COHORT_DETAILS,
            loginPageStore.userResponse.role.name,
            loginPageStore.userFeatures,
          )}
        ></FeatureAccessModal>
        <Snackbar
          {...snackbarState}
          handleClose={handleCloseSnackBar}
          vertical="bottom"
          horizontal="right"
        />
        <AiSummaryCard
          open={activeAskAi}
          onClose={() => {
            setActiveAskAi(false);
            setAiSummaryData([]);
          }}
          aiSummaryData={aiSummaryData}
          loading={aiLoading}
        />
      </>
    );
  },
);

export default UtilizationProcedurePage;
